const reports = {
    EN: {
        carMainReport: 'Generate report - Car',
        terminalInstallationReport: 'Generate report - terminal installation',
        activeTerminalsReport: 'Generate report - active terminals',
        vehiclesStateReport: 'Generate report - vehicles state',
        reportManualStep1: 'Wybierz zakres czasowy dla raportu wybierając <span>Zakres Dat</span> lub wybierając datę <span>Od i Do</span>.',
        reportManualStep1a: 'Choose day for generate active terminals raport',
        reportManualStep2: '<span>Dodaj pojazd</span> używając wysuwanej listy pojazdów.',
        reportManualStep3a: 'Przycisk <span>Wygeneruj raport</span> będzie aktywny gdy <span>Pojazd i Zakres Dat</span> zostanie wybrany.',
        reportManualStep3b: 'Przycisk <span>Wygeneruj raport</span> będzie aktywny gdy <span>Zakres Dat</span> zostanie wybrany.',
        reportManualStep4: 'Po wygenerowaniu raportu możesz <span>Wyeksportować raport</span> klikając w wybraną opcję.',
        reportManualVehiclesState1: 'Kliknij w przycisk <span>generuj raport</span> aby wygenerować aktualny raport o stanie pojazdów',
        reportManual: 'Manual',
        reportDateLength: 'Report date length',
        dataRangeDays: 'Data range days',
        addressStart: 'Start address',
        addressEnd: 'End address',
        reportSummary: 'Report Summary',
        gpsDistance: 'Distance GPS',
        maxSpeedKmh: 'Max speed',
        avgSpeedKmh: 'Average speed',
        gpsSignal: 'GPS Signal',
        gsmSignal: 'GSM Signal',
        dataframesCount: 'Dataframes count',
        inPoland: 'in Poland',
        outsidePoland: 'Outside Poland',
        timeSpend: 'Time spend',
        startMileageKm: 'Start mileage:',
        endMileageKm: 'End mileage:',
        exportToXLS: 'Export to XLS',
        exportToPDF: 'Export to PDF',
        exportToCSV: 'Export to CSV',
        velocity: 'Velocity',
        acceleration: 'Acceleration',
        carCollision: 'Collision',
        deviceId: 'Device Id',
        carModel: 'Car model',
        months: 'Months',
        address: 'Address',
        installationDate: 'Installation date',
        orderAuthorName: 'Order author name',
        orderNumber: 'Order number',
        orderReceivalDate: 'Order receival date',
        technicianName: 'Technican name',
        carSupplierCompanyName: 'Car supplier company name',
        generateReport: 'Generate report',
        mileage: 'Milegae',
        sellerProposalNumber: 'Seller proposal number',
        carCreationDate: 'Car creation date',
        receiveDate: 'Receive date',
        receiveCount: 'Receive count',
        numberOfReceivedFrames: 'Number of received frames',
        top: 'top',
        bottom: 'bottom',
        front: 'front',
        back: 'back',
        left: 'right',
        right: 'right',
    },
    PL: {
        carMainReport: 'Generuj raport - Pojazd',
        terminalInstallationReport: 'Generuj raport - instalacja terminalu',
        activeTerminalsReport: 'Generuj raport - aktywne terminale',
        vehiclesStateReport: 'Generuj raport - stan pojazdów',
        reportManualStep1: 'Wybierz zakres czasowy dla raportu wybierając <span>Zakres Dat</span> lub wybierając datę <span>Od i Do</span>.',
        reportManualStep1a: 'Wybierz <span>dzień</span> dla którego chcesz wygenerować raport aktywnych terminali.',
        reportManualStep2: '<span>Dodaj pojazd</span> używając wysuwanej listy pojazdów.',
        reportManualStep2a: 'Przycisk <span>Wygeneruj raport</span> będzie aktywny gdy <span>dzień</span> zostanie wybrany.',
        reportManualStep3a: 'Przycisk <span>Wygeneruj raport</span> będzie aktywny gdy <span>Pojazd i Zakres Dat</span> zostanie wybrany.',
        reportManualStep3b: 'Przycisk <span>Wygeneruj raport</span> będzie aktywny gdy <span>Zakres Dat</span> zostanie wybrany.',
        reportManualStep4: 'Po wygenerowaniu raportu możesz <span>Wyeksportować raport</span> klikając w wybraną opcję.',
        reportManualVehiclesState1: 'Kliknij w przycisk <span>generuj raport</span> aby wygenerować aktualny raport o stanie pojazdów',
        reportManual: 'Instrukcja',
        reportDateLength: 'Raport obejmuje',
        dataRangeDays: 'Dni objęte raportem',
        addressStart: 'Adres początkowy',
        addressEnd: 'Adres końcowy',
        reportSummary: 'Ogólnie',
        gpsDistance: 'Dystans GPS',
        maxSpeedKmh: 'Max prędkość',
        avgSpeedKmh: 'Średnia prędkość',
        gpsSignal: 'Sygnał GPS',
        gsmSignal: 'Sygnał GSM średnia',
        dataframesCount: 'Ilość danych',
        inPoland: 'W Polsce',
        outsidePoland: 'Za granicą',
        timeSpend: 'Czas spędzony',
        startMileageKm: 'Przebieg przed:',
        endMileageKm: 'Przebieg po:',
        exportToXLS: 'Eksportuj do XLS',
        exportToPDF: 'Eksportuj do PDF',
        exportToCSV: 'Eksportuj do CSV',
        velocity: 'Prędkość',
        acceleration: 'Przyspieszenie',
        carCollision: 'Wypadek',
        deviceId: 'Id terminala',
        carModel: 'Model pojazdu',
        months: 'Miesiące',
        address: 'Adres',
        installationDate: 'Data instalacji',
        orderAuthorName: 'Składający zamówienie',
        orderNumber: 'Numer zamówienia',
        orderReceivalDate: 'Data odebrania zamówienia',
        technicianName: 'Technik',
        carSupplierCompanyName: 'Firma wynajmująca pojazd',
        generateReport: 'Generuj raport',
        mileage: 'Przebieg',
        sellerProposalNumber: 'ID z systemu sprzedażowego',
        carCreationDate: 'W systemie od',
        receiveDate: 'Data otrzymania',
        receiveCount: 'Liczba otrzymanych',
        numberOfReceivedFrames: 'Liczba otrzymanych ramek',
        top: 'góra',
        bottom: 'dół',
        front: 'przód',
        back: 'tył',
        left: 'lewo',
        right: 'prawo',
    }
};

export default reports;



// WEBPACK FOOTER //
// ./src/Translations/Reports.ts